import styled from 'styled-components';

import { body } from '@constants/fonts';

export const PageMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: linear-gradient(
    144.21deg,
    ${({ theme }) => theme.palette.gradient.light} 20%,
    ${({ theme }) => theme.palette.gradient.dark} 80%
  );
`;

export const CenterContents = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-family: ${body};

  img {
    width: 50%;
  }
`;

export const Img = styled.img`
  max-width: 400px;
  min-width: 100px;
  max-height: 200px;
`;

export const Spacer = styled.div`
  height: 30px;
  width: 100%;
`;
